import React from 'react'
import {
  TopicInaccessibleGuard,
  TopicLanguageNotSupportedGuard,
  TopicLowAuthorCountGuard,
  TopicIndexNotReadyGuard,
  WidgetLoadingGuard
} from 'components/widget/share/guards'
import { WidgetGuard } from 'features/types'
import DemographicEmptyResultGuard from './DemographicEmptyResultGuard'
import DemographicCompareInvalidFilterGuard from './DemographicCompareInvalidFilterGuard'
import DemographicStatusFailGuard from './DemographicStatusFailGuard'

const PostSearchDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <WidgetLoadingGuard widgetId={widgetId}>
    <DemographicCompareInvalidFilterGuard widgetId={widgetId}>
      <TopicInaccessibleGuard widgetId={widgetId}>
        <DemographicStatusFailGuard widgetId={widgetId}>
          <TopicLanguageNotSupportedGuard widgetId={widgetId}>
            <TopicLowAuthorCountGuard widgetId={widgetId}>
              <TopicIndexNotReadyGuard widgetId={widgetId}>
                <DemographicEmptyResultGuard widgetId={widgetId}>
                  {children}
                </DemographicEmptyResultGuard>
              </TopicIndexNotReadyGuard>
            </TopicLowAuthorCountGuard>
          </TopicLanguageNotSupportedGuard>
        </DemographicStatusFailGuard>
      </TopicInaccessibleGuard>
    </DemographicCompareInvalidFilterGuard>
  </WidgetLoadingGuard>
)

export default PostSearchDataGuards
